export const PROFILE_EVENT_NAME = {
    RESIDENTIAL_ADDRESS_VERIFICATION_POPUP_ENTRY: {
        name: 'RESIDENTIAL_ADDRESS_VERIFICATION_POPUP_ENTRY',
        hasGA: true,
        hasDQ: true,
        hasCL: false
    },
    RESIDENTIAL_ADDRESS_VERIFICATION_POPUP_CLOSE: {
        name: 'RESIDENTIAL_ADDRESS_VERIFICATION_POPUP_CLOSE',
        hasGA: true,
        hasDQ: true,
        hasCL: false
    },
    RESIDENTIAL_ADDRESS_VERIFICATION_POPUP_SUBMIT: {
        name: 'RESIDENTIAL_ADDRESS_VERIFICATION_POPUP_SUBMIT',
        hasGA: true,
        hasDQ: true,
        hasCL: false
    },
    RESIDENTIAL_ADDRESS_VERIFICATION_POPUP_REJECT: {
        name: 'RESIDENTIAL_ADDRESS_VERIFICATION_POPUP_REJECT',
        hasGA: true,
        hasDQ: true,
        hasCL: false
    },
    RESIDENTIAL_ADDRESS_VERIFICATION_POPUP_EXIT: {
        name: 'RESIDENTIAL_ADDRESS_VERIFICATION_POPUP_EXIT',
        hasGA: true,
        hasDQ: true,
        hasCL: false
    },
    EDUCATION_VERIFICATION_POPUP_ENTRY: {
        name: 'EDUCATION_VERIFICATION_POPUP_ENTRY',
        hasGA: true,
        hasDQ: true,
        hasCL: false
    },
    EDUCATION_VERIFICATION_POPUP_CLOSE: {
        name: 'EDUCATION_VERIFICATION_POPUP_CLOSE',
        hasGA: true,
        hasDQ: true,
        hasCL: false
    },    
    EDUCATION_VERIFICATION_POPUP_SUBMIT: {
        name: 'EDUCATION_VERIFICATION_POPUP_SUBMIT',
        hasGA: true,
        hasDQ: true,
        hasCL: false
    },    
    EDUCATION_VERIFICATION_POPUP_REJECT: {
        name: 'EDUCATION_VERIFICATION_POPUP_REJECT',
        hasGA: true,
        hasDQ: true,
        hasCL: false
    },    
    EDUCATION_VERIFICATION_POPUP_EXIT: {
        name: 'EDUCATION_VERIFICATION_POPUP_EXIT',
        hasGA: true,
        hasDQ: true,
        hasCL: false
    },   
    EXPERIENCE_VERIFICATION_POPUP_ENTRY: {
        name: 'EXPERIENCE_VERIFICATION_POPUP_ENTRY',
        hasGA: true,
        hasDQ: true,
        hasCL: false
    },
    EXPERIENCE_VERIFICATION_POPUP_CLOSE: {
        name: 'EXPERIENCE_VERIFICATION_POPUP_CLOSE',
        hasGA: true,
        hasDQ: true,
        hasCL: false
    },    
    EXPERIENCE_VERIFICATION_POPUP_SUBMIT: {
        name: 'EXPERIENCE_VERIFICATION_POPUP_SUBMIT',
        hasGA: true,
        hasDQ: true,
        hasCL: false
    },    
    EXPERIENCE_VERIFICATION_POPUP_REJECT: {
        name: 'EXPERIENCE_VERIFICATION_POPUP_REJECT',
        hasGA: true,
        hasDQ: true,
        hasCL: false
    },    
    EXPERIENCE_VERIFICATION_POPUP_EXIT: {
        name: 'EXPERIENCE_VERIFICATION_POPUP_EXIT',
        hasGA: true,
        hasDQ: true,
        hasCL: false
    },    
    PRACTICE_DETAILS_VERIFICATION_POPUP_ENTRY: {
        name: 'PRACTICE_DETAILS_VERIFICATION_POPUP_ENTRY',
        hasGA: true,
        hasDQ: true,
        hasCL: false
    },    
    PRACTICE_DETAILS_VERIFICATION_POPUP_CLOSE: {
        name: 'PRACTICE_DETAILS_VERIFICATION_POPUP_CLOSE',
        hasGA: true,
        hasDQ: true,
        hasCL: false
    },    
    PRACTICE_DETAILS_VERIFICATION_POPUP_SUBMIT: {
        name: 'PRACTICE_DETAILS_VERIFICATION_POPUP_SUBMIT',
        hasGA: true,
        hasDQ: true,
        hasCL: false
    },    
    PRACTICE_DETAILS_VERIFICATION_POPUP_REJECT: {
        name: 'PRACTICE_DETAILS_VERIFICATION_POPUP_REJECT',
        hasGA: true,
        hasDQ: true,
        hasCL: false
    },    
    PRACTICE_DETAILS_VERIFICATION_POPUP_EXIT: {
        name: 'PRACTICE_DETAILS_VERIFICATION_POPUP_EXIT',
        hasGA: true,
        hasDQ: true,
        hasCL: false
    },    
    MEDICAL_AWARDS_VERIFICATION_POPUP_ENTRY: {
        name: 'MEDICAL_AWARDS_VERIFICATION_POPUP_ENTRY',
        hasGA: true,
        hasDQ: true,
        hasCL: false
    },    
    MEDICAL_AWARDS_VERIFICATION_POPUP_CLOSE: {
        name: 'MEDICAL_AWARDS_VERIFICATION_POPUP_CLOSE',
        hasGA: true,
        hasDQ: true,
        hasCL: false
    },    
    MEDICAL_AWARDS_VERIFICATION_POPUP_SUBMIT: {
        name: 'MEDICAL_AWARDS_VERIFICATION_POPUP_SUBMIT',
        hasGA: true,
        hasDQ: true,
        hasCL: false
    },    
    MEDICAL_AWARDS_VERIFICATION_POPUP_REJECT: {
        name: 'MEDICAL_AWARDS_VERIFICATION_POPUP_REJECT',
        hasGA: true,
        hasDQ: true,
        hasCL: false
    },    
    MEDICAL_AWARDS_VERIFICATION_POPUP_EXIT: {
        name: 'MEDICAL_AWARDS_VERIFICATION_POPUP_EXIT',
        hasGA: true,
        hasDQ: true,
        hasCL: false
    },    
    CIVIL_AWARDS_VERIFICATION_POPUP_ENTRY: {
        name: 'CIVIL_AWARDS_VERIFICATION_POPUP_ENTRY',
        hasGA: true,
        hasDQ: true,
        hasCL: false
    },    
    CIVIL_AWARDS_VERIFICATION_POPUP_CLOSE: {
        name: 'CIVIL_AWARDS_VERIFICATION_POPUP_CLOSE',
        hasGA: true,
        hasDQ: true,
        hasCL: false
    },    
    CIVIL_AWARDS_VERIFICATION_POPUP_SUBMIT: {
        name: 'CIVIL_AWARDS_VERIFICATION_POPUP_SUBMIT',
        hasGA: true,
        hasDQ: true,
        hasCL: false
    },   
    CIVIL_AWARDS_VERIFICATION_POPUP_REJECT: {
        name: 'CIVIL_AWARDS_VERIFICATION_POPUP_REJECT',
        hasGA: true,
        hasDQ: true,
        hasCL: false
    },    
    CIVIL_AWARDS_VERIFICATION_POPUP_EXIT: {
        name: 'CIVIL_AWARDS_VERIFICATION_POPUP_EXIT',
        hasGA: true,
        hasDQ: true,
        hasCL: false
    },    
    CERTIFICATIONS_VERIFICATION_POPUP_ENTRY: {
        name: 'CERTIFICATIONS_VERIFICATION_POPUP_ENTRY',
        hasGA: true,
        hasDQ: true,
        hasCL: false
    },    
    CERTIFICATIONS_VERIFICATION_POPUP_CLOSE: {
        name: 'CERTIFICATIONS_VERIFICATION_POPUP_CLOSE',
        hasGA: true,
        hasDQ: true,
        hasCL: false
    },    
    CERTIFICATIONS_VERIFICATION_POPUP_SUBMIT: {
        name: 'CERTIFICATIONS_VERIFICATION_POPUP_SUBMIT',
        hasGA: true,
        hasDQ: true,
        hasCL: false
    },    
    CERTIFICATIONS_VERIFICATION_POPUP_REJECT: {
        name: 'CERTIFICATIONS_VERIFICATION_POPUP_REJECT',
        hasGA: true,
        hasDQ: true,
        hasCL: false
    },    
    CERTIFICATIONS_VERIFICATION_POPUP_EXIT: {
        name: 'CERTIFICATIONS_VERIFICATION_POPUP_EXIT',
        hasGA: true,
        hasDQ: true,
        hasCL: false
    },    
    VOLUNTARY_SERVICE_VERIFICATION_POPUP_ENTRY: {
        name: 'VOLUNTARY_SERVICE_VERIFICATION_POPUP_ENTRY',
        hasGA: true,
        hasDQ: true,
        hasCL: false
    },
    VOLUNTARY_SERVICE_VERIFICATION_POPUP_CLOSE: {
        name: 'VOLUNTARY_SERVICE_VERIFICATION_POPUP_CLOSE',
        hasGA: true,
        hasDQ: true,
        hasCL: false
    },
    VOLUNTARY_SERVICE_VERIFICATION_POPUP_SUBMIT: {
        name: 'VOLUNTARY_SERVICE_VERIFICATION_POPUP_SUBMIT',
        hasGA: true,
        hasDQ: true,
        hasCL: false
    },
    VOLUNTARY_SERVICE_VERIFICATION_POPUP_REJECT: {
        name: 'VOLUNTARY_SERVICE_VERIFICATION_POPUP_REJECT',
        hasGA: true,
        hasDQ: true,
        hasCL: false
    },
    VOLUNTARY_SERVICE_VERIFICATION_POPUP_EXIT: {
        name: 'VOLUNTARY_SERVICE_VERIFICATION_POPUP_EXIT',
        hasGA: true,
        hasDQ: true,
        hasCL: false
    },
    PATENT_VERIFICATION_POPUP_ENTRY: {
        name: 'PATENT_VERIFICATION_POPUP_ENTRY',
        hasGA: true,
        hasDQ: true,
        hasCL: false
    },
    PATENT_VERIFICATION_POPUP_CLOSE: {
        name: 'PATENT_VERIFICATION_POPUP_CLOSE',
        hasGA: true,
        hasDQ: true,
        hasCL: false
    },
    PATENT_VERIFICATION_POPUP_SUBMIT: {
        name: 'PATENT_VERIFICATION_POPUP_SUBMIT',
        hasGA: true,
        hasDQ: true,
        hasCL: false
    },
    PATENT_VERIFICATION_POPUP_REJECT: {
        name: 'PATENT_VERIFICATION_POPUP_REJECT',
        hasGA: true,
        hasDQ: true,
        hasCL: false
    },
    PATENT_VERIFICATION_POPUP_EXIT: {
        name: 'PATENT_VERIFICATION_POPUP_EXIT',
        hasGA: true,
        hasDQ: true,
        hasCL: false
    },
    PAPER_PRESENTATION_VERIFICATION_POPUP_ENTRY: {
        name: 'PAPER_PRESENTATION_VERIFICATION_POPUP_ENTRY',
        hasGA: true,
        hasDQ: true,
        hasCL: false
    },
    PAPER_PRESENTATION_VERIFICATION_POPUP_CLOSE: {
        name: 'PAPER_PRESENTATION_VERIFICATION_POPUP_CLOSE',
        hasGA: true,
        hasDQ: true,
        hasCL: false
    },
    PAPER_PRESENTATION_VERIFICATION_POPUP_SUBMIT: {
        name: 'PAPER_PRESENTATION_VERIFICATION_POPUP_SUBMIT',
        hasGA: true,
        hasDQ: true,
        hasCL: false
    },
    PAPER_PRESENTATION_VERIFICATION_POPUP_REJECT: {
        name: 'PAPER_PRESENTATION_VERIFICATION_POPUP_REJECT',
        hasGA: true,
        hasDQ: true,
        hasCL: false
    },
    PAPER_PRESENTATION_VERIFICATION_POPUP_EXIT: {
        name: 'PAPER_PRESENTATION_VERIFICATION_POPUP_EXIT',
        hasGA: true,
        hasDQ: true,
        hasCL: false
    },
    THESIS_VERIFICATION_POPUP_ENTRY: {
        name: 'THESIS_VERIFICATION_POPUP_ENTRY',
        hasGA: true,
        hasDQ: true,
        hasCL: false
    },
    THESIS_VERIFICATION_POPUP_CLOSE: {
        name: 'THESIS_VERIFICATION_POPUP_CLOSE',
        hasGA: true,
        hasDQ: true,
        hasCL: false
    },
    THESIS_VERIFICATION_POPUP_SUBMIT: {
        name: 'THESIS_VERIFICATION_POPUP_SUBMIT',
        hasGA: true,
        hasDQ: true,
        hasCL: false
    },
    THESIS_VERIFICATION_POPUP_REJECT: {
        name: 'THESIS_VERIFICATION_POPUP_REJECT',
        hasGA: true,
        hasDQ: true,
        hasCL: false
    },
    THESIS_VERIFICATION_POPUP_EXIT: {
        name: 'THESIS_VERIFICATION_POPUP_EXIT',
        hasGA: true,
        hasDQ: true,
        hasCL: false
    },
    UNPUBLISHED_WORK_VERIFICATION_POPUP_ENTRY: {
        name: 'UNPUBLISHED_WORK_VERIFICATION_POPUP_ENTRY',
        hasGA: true,
        hasDQ: true,
        hasCL: false
    },
    UNPUBLISHED_WORK_VERIFICATION_POPUP_CLOSE: {
        name: 'UNPUBLISHED_WORK_VERIFICATION_POPUP_CLOSE',
        hasGA: true,
        hasDQ: true,
        hasCL: false
    },
    UNPUBLISHED_WORK_VERIFICATION_POPUP_SUBMIT: {
        name: 'UNPUBLISHED_WORK_VERIFICATION_POPUP_SUBMIT',
        hasGA: true,
        hasDQ: true,
        hasCL: false
    },
    UNPUBLISHED_WORK_VERIFICATION_POPUP_REJECT: {
        name: 'UNPUBLISHED_WORK_VERIFICATION_POPUP_REJECT',
        hasGA: true,
        hasDQ: true,
        hasCL: false
    },
    UNPUBLISHED_WORK_VERIFICATION_POPUP_EXIT: {
        name: 'UNPUBLISHED_WORK_VERIFICATION_POPUP_EXIT',
        hasGA: true,
        hasDQ: true,
        hasCL: false
    },
    POSITION_OF_RESPONSIBILITY_VERIFICATION_POPUP_ENTRY: {
        name: 'POSITION_OF_RESPONSIBILITY_VERIFICATION_POPUP_ENTRY',
        hasGA: true,
        hasDQ: true,
        hasCL: false
    },
    POSITION_OF_RESPONSIBILITY_VERIFICATION_POPUP_CLOSE: {
        name: 'POSITION_OF_RESPONSIBILITY_VERIFICATION_POPUP_CLOSE',
        hasGA: true,
        hasDQ: true,
        hasCL: false
    },
    POSITION_OF_RESPONSIBILITY_VERIFICATION_POPUP_SUBMIT: {
        name: 'POSITION_OF_RESPONSIBILITY_VERIFICATION_POPUP_SUBMIT',
        hasGA: true,
        hasDQ: true,
        hasCL: false
    },
    POSITION_OF_RESPONSIBILITY_VERIFICATION_POPUP_REJECT: {
        name: 'POSITION_OF_RESPONSIBILITY_VERIFICATION_POPUP_REJECT',
        hasGA: true,
        hasDQ: true,
        hasCL: false
    },
    POSITION_OF_RESPONSIBILITY_VERIFICATION_POPUP_EXIT: {
        name: 'POSITION_OF_RESPONSIBILITY_VERIFICATION_POPUP_EXIT',
        hasGA: true,
        hasDQ: true,
        hasCL: false
    },
    WORKSHOP_VERIFICATION_POPUP_ENTRY: {
        name: 'WORKSHOP_VERIFICATION_POPUP_ENTRY',
        hasGA: true,
        hasDQ: true,
        hasCL: false
    },
    WORKSHOP_VERIFICATION_POPUP_CLOSE: {
        name: 'WORKSHOP_VERIFICATION_POPUP_CLOSE',
        hasGA: true,
        hasDQ: true,
        hasCL: false
    },
    WORKSHOP_VERIFICATION_POPUP_SUBMIT: {
        name: 'WORKSHOP_VERIFICATION_POPUP_SUBMIT',
        hasGA: true,
        hasDQ: true,
        hasCL: false
    },
    WORKSHOP_VERIFICATION_POPUP_REJECT: {
        name: 'WORKSHOP_VERIFICATION_POPUP_REJECT',
        hasGA: true,
        hasDQ: true,
        hasCL: false
    },
    WORKSHOP_VERIFICATION_POPUP_EXIT: {
        name: 'WORKSHOP_VERIFICATION_POPUP_EXIT',
        hasGA: true,
        hasDQ: true,
        hasCL: false
    },
    SEMINAR_VERIFICATION_POPUP_ENTRY: {
        name: 'SEMINAR_VERIFICATION_POPUP_ENTRY',
        hasGA: true,
        hasDQ: true,
        hasCL: false
    },
    SEMINAR_VERIFICATION_POPUP_CLOSE: {
        name: 'SEMINAR_VERIFICATION_POPUP_CLOSE',
        hasGA: true,
        hasDQ: true,
        hasCL: false
    },
    SEMINAR_VERIFICATION_POPUP_SUBMIT: {
        name: 'SEMINAR_VERIFICATION_POPUP_SUBMIT',
        hasGA: true,
        hasDQ: true,
        hasCL: false
    },
    SEMINAR_VERIFICATION_POPUP_REJECT: {
        name: 'SEMINAR_VERIFICATION_POPUP_REJECT',
        hasGA: true,
        hasDQ: true,
        hasCL: false
    },
    SEMINAR_VERIFICATION_POPUP_EXIT: {
        name: 'SEMINAR_VERIFICATION_POPUP_EXIT',
        hasGA: true,
        hasDQ: true,
        hasCL: false
    },
    WEBINAR_VERIFICATION_POPUP_ENTRY: {
        name: 'WEBINAR_VERIFICATION_POPUP_ENTRY',
        hasGA: true,
        hasDQ: true,
        hasCL: false
    },
    WEBINAR_VERIFICATION_POPUP_CLOSE: {
        name: 'WEBINAR_VERIFICATION_POPUP_CLOSE',
        hasGA: true,
        hasDQ: true,
        hasCL: false
    },
    WEBINAR_VERIFICATION_POPUP_SUBMIT: {
        name: 'WEBINAR_VERIFICATION_POPUP_SUBMIT',
        hasGA: true,
        hasDQ: true,
        hasCL: false
    },
    WEBINAR_VERIFICATION_POPUP_REJECT: {
        name: 'WEBINAR_VERIFICATION_POPUP_REJECT',
        hasGA: true,
        hasDQ: true,
        hasCL: false
    },
    WEBINAR_VERIFICATION_POPUP_EXIT: {
        name: 'WEBINAR_VERIFICATION_POPUP_EXIT',
        hasGA: true,
        hasDQ: true,
        hasCL: false
    },
    CONFERENCE_VERIFICATION_POPUP_ENTRY: {
        name: 'CONFERENCE_VERIFICATION_POPUP_ENTRY',
        hasGA: true,
        hasDQ: true,
        hasCL: false
    },
    CONFERENCE_VERIFICATION_POPUP_CLOSE: {
        name: 'CONFERENCE_VERIFICATION_POPUP_CLOSE',
        hasGA: true,
        hasDQ: true,
        hasCL: false
    },
    CONFERENCE_VERIFICATION_POPUP_SUBMIT: {
        name: 'CONFERENCE_VERIFICATION_POPUP_SUBMIT',
        hasGA: true,
        hasDQ: true,
        hasCL: false
    },
    CONFERENCE_VERIFICATION_POPUP_REJECT: {
        name: 'CONFERENCE_VERIFICATION_POPUP_REJECT',
        hasGA: true,
        hasDQ: true,
        hasCL: false
    },
    CONFERENCE_VERIFICATION_POPUP_EXIT: {
        name: 'CONFERENCE_VERIFICATION_POPUP_EXIT',
        hasGA: true,
        hasDQ: true,
        hasCL: false
    },
    TRAININGS_RECEIVED_VERIFICATION_POPUP_ENTRY: {
        name: 'TRAININGS_RECEIVED_VERIFICATION_POPUP_ENTRY',
        hasGA: true,
        hasDQ: true,
        hasCL: false
    },
    TRAININGS_RECEIVED_VERIFICATION_POPUP_CLOSE: {
        name: 'TRAININGS_RECEIVED_VERIFICATION_POPUP_CLOSE',
        hasGA: true,
        hasDQ: true,
        hasCL: false
    },
    TRAININGS_RECEIVED_VERIFICATION_POPUP_SUBMIT: {
        name: 'TRAININGS_RECEIVED_VERIFICATION_POPUP_SUBMIT',
        hasGA: true,
        hasDQ: true,
        hasCL: false
    },
    TRAININGS_RECEIVED_VERIFICATION_POPUP_REJECT: {
        name: 'TRAININGS_RECEIVED_VERIFICATION_POPUP_REJECT',
        hasGA: true,
        hasDQ: true,
        hasCL: false
    },
    TRAININGS_RECEIVED_VERIFICATION_POPUP_EXIT: {
        name: 'TRAININGS_RECEIVED_VERIFICATION_POPUP_EXIT',
        hasGA: true,
        hasDQ: true,
        hasCL: false
    },
    TRAININGS_IMPARTED_VERIFICATION_POPUP_ENTRY: {
        name: 'TRAININGS_IMPARTED_VERIFICATION_POPUP_ENTRY',
        hasGA: true,
        hasDQ: true,
        hasCL: false
    },
    TRAININGS_IMPARTED_VERIFICATION_POPUP_CLOSE: {
        name: 'TRAININGS_IMPARTED_VERIFICATION_POPUP_CLOSE',
        hasGA: true,
        hasDQ: true,
        hasCL: false
    },
    TRAININGS_IMPARTED_VERIFICATION_POPUP_SUBMIT: {
        name: 'TRAININGS_IMPARTED_VERIFICATION_POPUP_SUBMIT',
        hasGA: true,
        hasDQ: true,
        hasCL: false
    },
    TRAININGS_IMPARTED_VERIFICATION_POPUP_REJECT: {
        name: 'TRAININGS_IMPARTED_VERIFICATION_POPUP_REJECT',
        hasGA: true,
        hasDQ: true,
        hasCL: false
    },
    TRAININGS_IMPARTED_VERIFICATION_POPUP_EXIT: {
        name: 'TRAININGS_IMPARTED_VERIFICATION_POPUP_EXIT',
        hasGA: true,
        hasDQ: true,
        hasCL: false
    },
    BLOG_VERIFICATION_POPUP_ENTRY: {
        name: 'BLOG_VERIFICATION_POPUP_ENTRY',
        hasGA: true,
        hasDQ: true,
        hasCL: false
    },
    BLOG_VERIFICATION_POPUP_CLOSE: {
        name: 'BLOG_VERIFICATION_POPUP_CLOSE',
        hasGA: true,
        hasDQ: true,
        hasCL: false
    },
    BLOG_VERIFICATION_POPUP_SUBMIT: {
        name: 'BLOG_VERIFICATION_POPUP_SUBMIT',
        hasGA: true,
        hasDQ: true,
        hasCL: false
    },
    BLOG_VERIFICATION_POPUP_REJECT: {
        name: 'BLOG_VERIFICATION_POPUP_REJECT',
        hasGA: true,
        hasDQ: true,
        hasCL: false
    },
    BLOG_VERIFICATION_POPUP_EXIT: {
        name: 'BLOG_VERIFICATION_POPUP_EXIT',
        hasGA: true,
        hasDQ: true,
        hasCL: false
    },
    CONSULTATION_DETAILS_VERIFICATION_POPUP_ENTRY: {
        name: 'CONSULTATION_DETAILS_VERIFICATION_POPUP_ENTRY',
        hasGA: true,
        hasDQ: true,
        hasCL: false
    },
    CONSULTATION_DETAILS_VERIFICATION_POPUP_CLOSE: {
        name: 'CONSULTATION_DETAILS_VERIFICATION_POPUP_CLOSE',
        hasGA: true,
        hasDQ: true,
        hasCL: false
    },
    CONSULTATION_DETAILS_VERIFICATION_POPUP_SUBMIT: {
        name: 'CONSULTATION_DETAILS_VERIFICATION_POPUP_SUBMIT',
        hasGA: true,
        hasDQ: true,
        hasCL: false
    },
    CONSULTATION_DETAILS_VERIFICATION_POPUP_REJECT: {
        name: 'CONSULTATION_DETAILS_VERIFICATION_POPUP_REJECT',
        hasGA: true,
        hasDQ: true,
        hasCL: false
    },
    CONSULTATION_DETAILS_VERIFICATION_POPUP_EXIT: {
        name: 'CONSULTATION_DETAILS_VERIFICATION_POPUP_EXIT',
        hasGA: true,
        hasDQ: true,
        hasCL: false
    },
    PUBLICATION_VERIFICATION_POPUP_ENTRY: {
        name: 'PUBLICATION_VERIFICATION_POPUP_ENTRY',
        hasGA: true,
        hasDQ: true,
        hasCL: false
    },
    PUBLICATION_VERIFICATION_POPUP_CLOSE: {
        name: 'PUBLICATION_VERIFICATION_POPUP_CLOSE',
        hasGA: true,
        hasDQ: true,
        hasCL: false
    },
    PUBLICATION_VERIFICATION_POPUP_SUBMIT: {
        name: 'PUBLICATION_VERIFICATION_POPUP_SUBMIT',
        hasGA: true,
        hasDQ: true,
        hasCL: false
    },
    PUBLICATION_VERIFICATION_POPUP_REJECT: {
        name: 'PUBLICATION_VERIFICATION_POPUP_REJECT',
        hasGA: true,
        hasDQ: true,
        hasCL: false
    },
    PUBLICATION_VERIFICATION_POPUP_EXIT: {
        name: 'PUBLICATION_VERIFICATION_POPUP_EXIT',
        hasGA: true,
        hasDQ: true,
        hasCL: false
    },
    CERTIFICATION_VERIFICATION_POPUP_EXIT: { 
        name: 'CERTIFICATION_VERIFICATION_POPUP_EXIT',
        hasGA: true,
        hasDQ: true,
        hasCL: false
    },
    CERTIFICATION_VERIFICATION_POPUP_CLOSE: {
        name: 'CERTIFICATION_VERIFICATION_POPUP_CLOSE',
        hasGA: true,
        hasDQ: true,
        hasCL: false
    },
    CERTIFICATION_VERIFICATION_POPUP_SUBMIT: {
        name: 'CERTIFICATION_VERIFICATION_POPUP_SUBMIT',
        hasGA: true,
        hasDQ: true,
        hasCL: false
    },
    CERTIFICATION_VERIFICATION_POPUP_REJECT: {
        name: 'CERTIFICATION_VERIFICATION_POPUP_REJECT',
        hasGA: true,
        hasDQ: true,
        hasCL: false
    },
    CERTIFICATION_DETAILS_VERIFICATION_POPUP_EXIT: {
        name: 'CERTIFICATION_DETAILS_VERIFICATION_POPUP_EXIT',
        hasGA: true,
        hasDQ: true,
        hasCL: false
    }
 }
export const NUDGE_PARAMETER_EVENTS = {
    RESIDENTIAL_ADDRESS: {
        'ENTRY': 'RESIDENTIAL_ADDRESS_VERIFICATION_POPUP_ENTRY',
        'CLOSE': 'RESIDENTIAL_ADDRESS_VERIFICATION_POPUP_CLOSE',
        'SUBMIT': 'RESIDENTIAL_ADDRESS_VERIFICATION_POPUP_SUBMIT',
        'DECLINE': 'RESIDENTIAL_ADDRESS_VERIFICATION_POPUP_REJECT',
        'EXIT': 'RESIDENTIAL_ADDRESS_VERIFICATION_POPUP_EXIT',
    },
    EDUCATION: {
        'ENTRY': 'EDUCATION_VERIFICATION_POPUP_ENTRY',
        'CLOSE': 'EDUCATION_VERIFICATION_POPUP_CLOSE',
        'SUBMIT': 'EDUCATION_VERIFICATION_POPUP_SUBMIT',
        'DECLINE': 'EDUCATION_VERIFICATION_POPUP_REJECT',
        'EXIT': 'EDUCATION_VERIFICATION_POPUP_EXIT'
    },
    EXPERIENCE: {
        'ENTRY': 'EXPERIENCE_VERIFICATION_POPUP_ENTRY',
        'CLOSE': 'EXPERIENCE_VERIFICATION_POPUP_CLOSE',
        'SUBMIT': 'EXPERIENCE_VERIFICATION_POPUP_SUBMIT',
        'DECLINE': 'EXPERIENCE_VERIFICATION_POPUP_REJECT',
        'EXIT': 'EXPERIENCE_VERIFICATION_POPUP_EXIT'
    },
    PRACTICE_DETAILS: {
        'ENTRY': 'PRACTICE_DETAILS_VERIFICATION_POPUP_ENTRY',
        'CLOSE': 'PRACTICE_DETAILS_VERIFICATION_POPUP_CLOSE',
        'SUBMIT': 'PRACTICE_DETAILS_VERIFICATION_POPUP_SUBMIT',
        'DECLINE': 'PRACTICE_DETAILS_VERIFICATION_POPUP_REJECT',
        'EXIT': 'PRACTICE_DETAILS_VERIFICATION_POPUP_EXIT'
    },
    MEDICAL_AWARDS: {
        'ENTRY': 'MEDICAL_AWARDS_VERIFICATION_POPUP_ENTRY',
        'CLOSE': 'MEDICAL_AWARDS_VERIFICATION_POPUP_CLOSE',
        'SUBMIT': 'MEDICAL_AWARDS_VERIFICATION_POPUP_SUBMIT',
        'DECLINE': 'MEDICAL_AWARDS_VERIFICATION_POPUP_REJECT',
        'EXIT': 'MEDICAL_AWARDS_VERIFICATION_POPUP_EXIT'
    },
    CIVIL_AWARDS: {
        'ENTRY': 'CIVIL_AWARDS_VERIFICATION_POPUP_ENTRY',
        'CLOSE': 'CIVIL_AWARDS_VERIFICATION_POPUP_CLOSE',
        'SUBMIT': 'CIVIL_AWARDS_VERIFICATION_POPUP_SUBMIT',
        'DECLINE': 'CIVIL_AWARDS_VERIFICATION_POPUP_REJECT',
        'EXIT': 'CIVIL_AWARDS_VERIFICATION_POPUP_EXIT'
    },
    CERTIFICATION: {
        'ENTRY': 'CERTIFICATIONS_VERIFICATION_POPUP_ENTRY',
        'CLOSE': 'CERTIFICATIONS_VERIFICATION_POPUP_CLOSE',
        'SUBMIT': 'CERTIFICATIONS_VERIFICATION_POPUP_SUBMIT',
        'DECLINE': 'CERTIFICATIONS_VERIFICATION_POPUP_REJECT',
        'EXIT': 'CERTIFICATIONS_VERIFICATION_POPUP_EXIT'
    },
    VOLUNTARY_SERVICE: {
        'ENTRY': 'VOLUNTARY_SERVICE_VERIFICATION_POPUP_ENTRY',
        'CLOSE': 'VOLUNTARY_SERVICE_VERIFICATION_POPUP_CLOSE',
        'SUBMIT': 'VOLUNTARY_SERVICE_VERIFICATION_POPUP_SUBMIT',
        'DECLINE': 'VOLUNTARY_SERVICE_VERIFICATION_POPUP_REJECT',
        'EXIT': 'VOLUNTARY_SERVICE_VERIFICATION_POPUP_EXIT'
    },
    PATENT: {
        'ENTRY': 'PATENT_VERIFICATION_POPUP_ENTRY',
        'CLOSE': 'PATENT_VERIFICATION_POPUP_CLOSE',
        'SUBMIT': 'PATENT_VERIFICATION_POPUP_SUBMIT',
        'DECLINE': 'PATENT_VERIFICATION_POPUP_REJECT',
        'EXIT': 'PATENT_VERIFICATION_POPUP_EXIT'
    },
    PAPER_PRESENTATION: {
        'ENTRY': 'PAPER_PRESENTATION_VERIFICATION_POPUP_ENTRY',
        'CLOSE': 'PAPER_PRESENTATION_VERIFICATION_POPUP_CLOSE',
        'SUBMIT': 'PAPER_PRESENTATION_VERIFICATION_POPUP_SUBMIT',
        'DECLINE': 'PAPER_PRESENTATION_VERIFICATION_POPUP_REJECT',
        'EXIT': 'PAPER_PRESENTATION_VERIFICATION_POPUP_EXIT'
    },
    THESIS: {
        'ENTRY': 'THESIS_VERIFICATION_POPUP_ENTRY',
        'CLOSE': 'THESIS_VERIFICATION_POPUP_CLOSE',
        'SUBMIT': 'THESIS_VERIFICATION_POPUP_SUBMIT',
        'DECLINE': 'THESIS_VERIFICATION_POPUP_REJECT',
        'EXIT':  'THESIS_VERIFICATION_POPUP_EXIT'
    },
    UNPUBLISHED_WORK: {
        'ENTRY': 'UNPUBLISHED_WORK_VERIFICATION_POPUP_ENTRY',
        'CLOSE': 'UNPUBLISHED_WORK_VERIFICATION_POPUP_CLOSE',
        'SUBMIT': 'UNPUBLISHED_WORK_VERIFICATION_POPUP_SUBMIT',
        'DECLINE': 'UNPUBLISHED_WORK_VERIFICATION_POPUP_REJECT',
        'EXIT': 'UNPUBLISHED_WORK_VERIFICATION_POPUP_EXIT'
    },
    POSITION_OF_RESPONSIBILITY: {
        'ENTRY': 'POSITION_OF_RESPONSIBILITY_VERIFICATION_POPUP_ENTRY',
        'CLOSE': 'POSITION_OF_RESPONSIBILITY_VERIFICATION_POPUP_CLOSE',
        'SUBMIT': 'POSITION_OF_RESPONSIBILITY_VERIFICATION_POPUP_SUBMIT',
        'DECLINE': 'POSITION_OF_RESPONSIBILITY_VERIFICATION_POPUP_REJECT',
        'EXIT': 'POSITION_OF_RESPONSIBILITY_VERIFICATION_POPUP_EXIT'
    },
    WORKSHOP: {
        'ENTRY': 'WORKSHOP_VERIFICATION_POPUP_ENTRY',
        'CLOSE': 'WORKSHOP_VERIFICATION_POPUP_CLOSE',
        'SUBMIT': 'WORKSHOP_VERIFICATION_POPUP_SUBMIT',
        'DECLINE': 'WORKSHOP_VERIFICATION_POPUP_REJECT',
        'EXIT':  'WORKSHOP_VERIFICATION_POPUP_EXIT'
    },
    SEMINAR: {
        'ENTRY': 'SEMINAR_VERIFICATION_POPUP_ENTRY',
        'CLOSE': 'SEMINAR_VERIFICATION_POPUP_CLOSE',
        'SUBMIT': 'SEMINAR_VERIFICATION_POPUP_SUBMIT',
        'DECLINE': 'SEMINAR_VERIFICATION_POPUP_REJECT',
        'EXIT': 'SEMINAR_VERIFICATION_POPUP_EXIT'
    },
    WEBINAR: {
        'ENTRY': 'WEBINAR_VERIFICATION_POPUP_ENTRY',
        'CLOSE': 'WEBINAR_VERIFICATION_POPUP_CLOSE',
        'SUBMIT': 'WEBINAR_VERIFICATION_POPUP_SUBMIT',
        'DECLINE': 'WEBINAR_VERIFICATION_POPUP_REJECT',
        'EXIT': 'WEBINAR_VERIFICATION_POPUP_EXIT'
    },
    CONFERENCE: {
        'ENTRY': 'CONFERENCE_VERIFICATION_POPUP_ENTRY',
        'CLOSE': 'CONFERENCE_VERIFICATION_POPUP_CLOSE',
        'SUBMIT': 'CONFERENCE_VERIFICATION_POPUP_SUBMIT',
        'DECLINE': 'CONFERENCE_VERIFICATION_POPUP_REJECT',
        'EXIT': 'CONFERENCE_VERIFICATION_POPUP_EXIT'
    },
    TRAININGS_RECEIVED: {
        'ENTRY': 'TRAININGS_RECEIVED_VERIFICATION_POPUP_ENTRY',
        'CLOSE': 'TRAININGS_RECEIVED_VERIFICATION_POPUP_CLOSE',
        'SUBMIT': 'TRAININGS_RECEIVED_VERIFICATION_POPUP_SUBMIT',
        'DECLINE': 'TRAININGS_RECEIVED_VERIFICATION_POPUP_REJECT',
        'EXIT': 'TRAININGS_RECEIVED_VERIFICATION_POPUP_EXIT'
    },
    TRAININGS_IMPARTED: {
        'ENTRY': 'TRAININGS_IMPARTED_VERIFICATION_POPUP_ENTRY',
        'CLOSE': 'TRAININGS_IMPARTED_VERIFICATION_POPUP_CLOSE',
        'SUBMIT': 'TRAININGS_IMPARTED_VERIFICATION_POPUP_SUBMIT',
        'DECLINE': 'TRAININGS_IMPARTED_VERIFICATION_POPUP_REJECT',
        'EXIT': 'TRAININGS_IMPARTED_VERIFICATION_POPUP_EXIT'
    },
    BLOG: {
        'ENTRY': 'BLOG_VERIFICATION_POPUP_ENTRY',
        'CLOSE': 'BLOG_PRESENTATION_VERIFICATION_POPUP_CLOSE',
        'SUBMIT': 'BLOG_PRESENTATION_VERIFICATION_POPUP_SUBMIT',
        'DECLINE': 'BLOG_PRESENTATION_VERIFICATION_POPUP_REJECT',
        'EXIT': 'BLOG_PRESENTATION_VERIFICATION_POPUP_EXIT'
    },
    CONSULTATION_DETAILS: {
        'ENTRY': 'CONSULTATION_DETAILS_VERIFICATION_POPUP_ENTRY',
        'CLOSE': 'CONSULTATION_DETAILS_VERIFICATION_POPUP_CLOSE',
        'SUBMIT': 'CONSULTATION_DETAILS_VERIFICATION_POPUP_SUBMIT',
        'DECLINE': 'CONSULTATION_DETAILS_VERIFICATION_POPUP_REJECT',
        'EXIT': 'CONSULTATION_DETAILS_VERIFICATION_POPUP_EXIT'
    },
    PUBLICATION: {
        'ENTRY': 'PUBLICATION_VERIFICATION_POPUP_ENTRY',
        'CLOSE': 'PUBLICATION_VERIFICATION_POPUP_CLOSE',
        'SUBMIT': 'PUBLICATION_VERIFICATION_POPUP_SUBMIT',
        'DECLINE': 'PUBLICATION_VERIFICATION_POPUP_REJECT',
        'EXIT': 'PUBLICATION_VERIFICATION_POPUP_EXIT'
    }
}

export const SCREEN_NAME_MAP = {
    RESIDENTIAL_ADDRESS: 'RESIDENTIAL_ADDRESS_VERIFICATION_POPUP',
    EDUCATION: 'EDUCATION_VERIFICATION_POPUP',
    EXPERIENCE: 'EXPERIENCE_VERIFICATION_POPUP',
    PRACTICE_DETAILS: 'PRACTICE_DETAILS_VERIFICATION_POPUP',
    MEDICAL_AWARDS: 'MEDICAL_AWARDS_VERIFICATION_POPUP',
    CIVIL_AWARDS: 'CIVIL_AWARDS_VERIFICATION_POPUP',
    CERTIFICATIONS: 'CERTIFICATIONS_VERIFICATION_POPUP',
    VOLUNTARY_SERVICE: 'VOLUNTARY_SERVICE_VERIFICATION_POPUP',
    PATENT: 'PATENT_VERIFICATION_POPUP',
    PAPER_PRESENTATION: 'PAPER_PRESENTATION_VERIFICATION_POPUP',
    THESIS: 'THESIS_VERIFICATION_POPUP',
    UNPUBLISHED_WORK: 'UNPUBLISHED_WORK_VERIFICATION_POPUP',
    POSITION_OF_RESPONSIBILITY: 'POSITION_OF_RESPONSIBILITY_VERIFICATION_POPUP',
    WORKSHOP: 'WORKSHOP_VERIFICATION_POPUP',
    SEMINAR: 'SEMINAR_VERIFICATION_POPUP',
    WEBINAR: 'WEBINAR_VERIFICATION_POPUP',
    CONFERENCE: 'CONFERENCE_VERIFICATION_POPUP',
    TRAININGS_RECEIVED: 'TRAININGS_RECEIVED_VERIFICATION_POPUP',
    TRAININGS_IMPARTED: 'TRAININGS_IMPARTED_VERIFICATION_POPUP',
    BLOG: 'BLOG_VERIFICATION_POPUP',
    CONSULTATION_DETAILS: 'CONSULTATION_DETAILS_VERIFICATION_POPUP',
    CERTIFICATION: 'CERTIFICATIONS_DETAILS_VERIFICATION_POPUP',
    PUBLICATION: 'PUBLICATION_VERIFICATION_POPUP'
}

export const PROFILE_ANALYTICS_SCENERIO = {
    'ENTRY': 'ENTRY',
    'CLOSE': 'CLOSE',
    'SUBMIT': 'SUBMIT',
    'DECLINE': 'DECLINE',
    'EXIT': 'EXIT'
}
